import { Fragment, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import CommunityRating from "./CommunityRating";
import GameDetailCard from "../ui/GameDetailCard";
import Image from "next/image";
import Kosana from "../kosana/Kosana";
import Link from "next/link";
import PopularNewsCard from "../news/PopularNewsCard";
import styles from "./Game.module.css";
import BannerRow from "../kosana/BannerRow";
import type { BannerAd } from "../../utils/homeData";
import guideImage from "../../assets/images/guide.webp";
import { resolveImageSrc, DEFAULT_AVATAR } from "../../utils/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
const Select = dynamic(() => import("react-select"), {
  ssr: false,
  // The control's own height (selectStyles: 44px), so it does not shift on load.
  loading: () => <div className="h-11 w-40 bg-theme-surface" />,
});
import GameList from "./GameList";

const GameComponent = (props: any) => {
  const [sorted, setSorted] = useState("Latest");
  const [topic, setTopic] = useState("");
  const [haveReview, setHaveReview] = useState(false);
  const [pages, setPages] = useState(1);
  const [totalContent, setTotalContent] = useState(0);
  const [contentReview, setContentReview] = useState({
    thumbnail: "",
    title: "",
    _id: "",
    game: [],
    author: [],
    description: "",
  });
  const [reviewThumbnailError, setReviewThumbnailError] = useState(false);
  let score: any;
  if (props.reviewScore) {
    score =
      (props.reviewScore.story +
        props.reviewScore.graphicAndSound +
        props.reviewScore.gameplay +
        props.reviewScore.performance) /
      4;
  }
  const [topicContent, setTopicContent] = useState({
    latestContent: [],
    newsContent: [],
    featureContent: [],
    guideContent: [],
    totalContent: 0,
  });
  const selectTopic = (topic: string) => {
    setTopic(topic);
  };
  let activeNews = topic === "news" ? `${styles.active}` : "";
  let activeReview = topic === "review" ? `${styles.active}` : "";
  let activeFeatures = topic === "features" ? `${styles.active}` : "";
  let activeGuides = topic === "guides" ? `${styles.active}` : "";

  let filters: string;
  if (topic === "news") {
    filters = "News";
  } else if (topic === "review") {
    filters = "Review,ReviewBanner";
  } else if (topic === "features") {
    filters = "Feature";
  } else if (topic === "guides") {
    filters = "Guide";
  }

  let sortType = "desc";
  let sortBy = "publishDt";
  if (sorted === "A-Z") {
    sortBy = "title";
    sortType = "asc";
  } else if (sorted === "Z-A") {
    sortBy = "title";
    sortType = "desc";
  } else if (sorted === "Latest") {
    sortType = "desc";
    sortBy = "publishDt";
  }

  useEffect(() => {
    if (topic === "news") {
      fetch(
        `${
          process.env.BACKEND_BASE_URL
        }/games/contents?page=${pages}&size=12&status=Published&category=${filters}${
          props.gameId ? "&gameId=" + props.gameId : ""
        }&sortBy=${sortBy}&sortType=${sortType}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const topicContents: any = [];
          if (data.success == true) {
            data.data.forEach(
              (topic: {
                publishDt: Date;
                _id: string;
                title: string;
                description: string;
                thumbnail: string;
                thumbnailResize: string;
                author: string;
                rating: number;
                game: string[];
                view?: number;
              }) => {
                topicContents.push({
                  _id: topic._id,
                  title: topic.title,
                  description: topic.description,
                  thumbnail: topic.thumbnail,
                  thumbnailResize: topic.thumbnailResize,
                  author: topic.author,
                  publishDt: topic.publishDt,
                  rating: topic.rating,
                  game: topic.game,
                  view: topic.view,
                });
              }
            );
            setTotalContent(data.data[0].totalCount);
            setTopicContent({ ...topicContent, latestContent: topicContents });
          } else if (data.data.statusCode == 404) {
            setTotalContent(0);
          }
        });
    } else if (topic === "review") {
      fetch(
        `${
          process.env.BACKEND_BASE_URL
        }/games/contents?page=${pages}&size=12&status=Published&category=${filters}${
          props.gameId ? "&gameId=" + props.gameId : ""
        }&sortBy=${sortBy}&sortType=${sortType}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const topicContents: any = [];
          if (data.success == true) {
            data.data.forEach(
              (topic: {
                publishDt: Date;
                _id: string;
                title: string;
                description: string;
                thumbnail: string;
                thumbnailResize: string;
                author: string;
                rating: number;
                game: string[];
                view?: number;
              }) => {
                topicContents.push({
                  _id: topic._id,
                  title: topic.title,
                  description: topic.description,
                  thumbnail: topic.thumbnail,
                  thumbnailResize: topic.thumbnailResize,
                  author: topic.author,
                  publishDt: topic.publishDt,
                  rating: topic.rating,
                  game: topic.game,
                  view: topic.view,
                });
              }
            );
            setTotalContent(data.data[0].totalCount);
            setTopicContent({ ...topicContent, newsContent: topicContents });
          } else if (data.data.statusCode == 404) {
            setTotalContent(0);
          }
        });
    } else if (topic === "features") {
      fetch(
        `${
          process.env.BACKEND_BASE_URL
        }/games/contents?page=${pages}&size=12&status=Published&category=${filters}${
          props.gameId ? "&gameId=" + props.gameId : ""
        }&sortBy=${sortBy}&sortType=${sortType}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const topicContents: any = [];
          if (data.success == true) {
            data.data.forEach(
              (topic: {
                publishDt: Date;
                _id: string;
                title: string;
                description: string;
                thumbnail: string;
                thumbnailResize: string;
                author: string;
                rating: number;
                game: string[];
                view?: number;
              }) => {
                topicContents.push({
                  _id: topic._id,
                  title: topic.title,
                  description: topic.description,
                  thumbnail: topic.thumbnail,
                  thumbnailResize: topic.thumbnailResize,
                  author: topic.author,
                  publishDt: topic.publishDt,
                  rating: topic.rating,
                  game: topic.game,
                  view: topic.view,
                });
              }
            );
            setTotalContent(data.data[0].totalCount);
            setTopicContent({ ...topicContent, featureContent: topicContents });
          } else if (data.data.statusCode == 404) {
            setTotalContent(0);
          }
        });
    } else if (topic === "guides") {
      fetch(
        `${
          process.env.BACKEND_BASE_URL
        }/games/contents?page=${pages}&size=12&status=Published&category=${filters}${
          props.gameId ? "&gameId=" + props.gameId : ""
        }&sortBy=${sortBy}&sortType=${sortType}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const topicContents: any = [];
          if (data.success == true) {
            data.data.forEach(
              (topic: {
                publishDt: Date;
                _id: string;
                title: string;
                description: string;
                thumbnail: string;
                thumbnailResize: string;
                author: string;
                rating: number;
                game: string[];
                view?: number;
              }) => {
                topicContents.push({
                  _id: topic._id,
                  title: topic.title,
                  description: topic.description,
                  thumbnail: topic.thumbnail,
                  thumbnailResize: topic.thumbnailResize,
                  author: topic.author,
                  publishDt: topic.publishDt,
                  rating: topic.rating,
                  game: topic.game,
                  view: topic.view,
                });
              }
            );
            setTotalContent(data.data[0].totalCount);
            setTopicContent({ ...topicContent, guideContent: topicContents });
          } else if (data.data.statusCode == 404) {
            setTotalContent(0);
          }
        });
    }
  }, [topic, sorted, pages]);

  useEffect(() => {
    fetch(`${process.env.BACKEND_BASE_URL}/contents/review/${props.gameId}`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success == true && Array.isArray(data.data) && data.data.length > 0) {
          setHaveReview(true);
          setContentReview(data.data[0]);
          setReviewThumbnailError(false);
        }
      });
  }, []);

  const sortingOption = [
    { value: "Latest", label: "Latest" },
    { value: "A-Z", label: "A-Z" },
    { value: "Z-A", label: "Z-A" },
  ];

  const calculatePagesCount = (pageSize, totalCount) => {
    if (totalCount == 0) {
      return;
    }
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const itemElements = [];
  for (let i = 1; i < calculatePagesCount(12, totalContent) + 1; i++) {
    itemElements.push(
      <li key={i}>
        <button
          type="button"
          onClick={() => setPages(i)}
          aria-current={pages == i ? "page" : undefined}
          className={`flex h-9 min-w-[2.25rem] items-center justify-center px-2 font-display text-sm font-semibold tabular-nums transition-colors duration-150 ${
            pages == i
              ? "bg-signal text-white"
              : "bg-theme-surface text-theme-text hover:text-signal dark:hover:text-[#8DB4FF]"
          }`}
        >
          {i}
        </button>
      </li>
    );
  }

  const [haveNews, setHaveNews] = useState(false);
  const [haveFeature, setHaveFeature] = useState(false);
  const [haveGuide, sethaveGuide] = useState(false);
  const [newData, setNewdata] = useState([]);
  useEffect(() => {
    const sortOrder = ["Guide", "Feature", "News", "Review"];
    if (props.categories) {
      setNewdata(props?.categories.filter((item) => item !== "Review"));
      const sortedArray = props?.categories.sort((a, b) => {
        return sortOrder.indexOf(a) - sortOrder.indexOf(b);
      });

      sortedArray.map((value) => {
        if (value === "Guide") {
          sethaveGuide(true);
        }

        if (value === "Feature") {
          setHaveFeature(true);
        }

        if (value === "News") {
          setHaveNews(true);
        }
      });

      if (props.categories[0] === "Review") {
        setTopic(
          props.categories[1] === "Guide"
            ? "guides"
            : props.categories[1] === "Feature"
            ? "features"
            : "news"
        );
      } else {
        setTopic(
          props.categories[0] === "Guide"
            ? "guides"
            : props.categories[0] === "Feature"
            ? "features"
            : "news"
        );
      }
    }
  }, []);

  // On Air spec input: hard-edged, 44px, signal border + ring on focus.
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 44,
      minWidth: 160,
      borderRadius: 3,
      backgroundColor: 'var(--color-card)',
      borderColor: state.isFocused ? '#005CFF' : 'var(--color-border)',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 92, 255, 0.3)' : 'none',
      color: 'var(--color-text)',
      cursor: 'pointer',
      '&:hover': { borderColor: '#005CFF' },
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--color-text)',
    }),
    placeholder: (base) => ({
      ...base,
      color: 'var(--color-text-secondary)',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 3,
      backgroundColor: 'var(--color-card)',
      border: '1px solid var(--color-border)',
      boxShadow: '0 18px 40px -12px rgba(0, 6, 20, 0.55)',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#005CFF' : state.isFocused ? 'var(--color-surface)' : 'var(--color-card)',
      color: state.isSelected ? '#FFFFFF' : 'var(--color-text)',
      cursor: 'pointer',
    }),
    input: (base) => ({
      ...base,
      color: 'var(--color-text)',
    }),
  };
  const resolvedReviewThumbnail = resolveImageSrc(contentReview.thumbnail);
  const reviewThumbnailSrc =
    !reviewThumbnailError && resolvedReviewThumbnail
      ? resolvedReviewThumbnail
      : guideImage;
  const reviewParts = props.reviewScore
    ? [
        { label: "Story", value: props.reviewScore.story },
        { label: "Design", value: props.reviewScore.graphicAndSound },
        { label: "Gameplay", value: props.reviewScore.gameplay },
        { label: "Performance", value: props.reviewScore.performance },
      ]
    : [];
  // One score rule site-wide (ArticleCard, Top 10): 9, 9.5, 9.75; only when
  // all four parts were filled in (unscored games carry nulls).
  const reviewScoreText =
    reviewParts.length === 4 && reviewParts.every((part) => typeof part.value === "number")
      ? String(Math.round(score * 100) / 100)
      : "–";
  const topicTabs = [
    { key: "guides", label: "Guides", show: haveGuide },
    { key: "features", label: "Features", show: haveFeature },
    { key: "news", label: "News", show: haveNews },
  ];
  return (
    <Fragment>
      <div className="relative bg-theme-bg pb-10">
        <div className="container mx-auto xl:px-24 lg:px-12 flex flex-col gap-4 md:px-8 px-4 w-full">
          {/* TODO: can make this to reuse component */}
          <nav aria-label="Breadcrumb" className="pt-6 md:pt-8">
            <ol className="m-0 flex min-w-0 list-none items-center gap-2 p-0 text-sm font-medium text-theme-text-secondary">
              <li className="shrink-0">
                <Link href="/" prefetch={false} className="transition-colors hover:text-signal dark:hover:text-[#8DB4FF]">Home</Link>
              </li>
              <li aria-hidden="true" className="shrink-0">
                <FontAwesomeIcon icon={faAngleRight} className="text-xs" />
              </li>
              <li className="shrink-0">
                <Link href={`/calendar`} className="transition-colors hover:text-signal dark:hover:text-[#8DB4FF]">All games</Link>
              </li>
              <li aria-hidden="true" className="shrink-0">
                <FontAwesomeIcon icon={faAngleRight} className="text-xs" />
              </li>
              <li className="min-w-0 truncate text-theme-text" aria-current="page">
                {props.title}
              </li>
            </ol>
          </nav>
          <div className="flex flex-col w-full flex-1">
            <GameDetailCard id={props.gameId} gamePage={true} initialGame={props.initialGame} guideSlug={props.guideSlug} />
          </div>
        </div>
      </div>
      {/* Straight under the hero, and outside the content-list condition, so a
          game without articles still gets both banners. */}
      <div className="container mx-auto xl:px-24 lg:px-12 md:px-8 px-4 w-full z-10 pt-6">
        <BannerRow
          mock="facebook"
          initialBannerAd={props.initialBannerAd as BannerAd | null | undefined}
          initialSquareAd={props.initialSquareAd as BannerAd | null | undefined}
          className=""
        />
      </div>
      {haveReview && props.reviewScore ? (
        <div className="pb-4 pt-10">
          <div className="container mx-auto xl:px-24 lg:px-12 flex flex-col gap-4 md:px-8 px-4 w-full z-10">
            <h2 className="seg-title self-start">Review</h2>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_340px] xl:grid-cols-[minmax(0,1fr)_380px]">
              {/* The verdict: the score bug on its panel header, then the parts */}
              <div className="min-w-0 overflow-hidden rounded-[4px] bg-theme-card">
                <div className="flex items-stretch">
                  <span className="score-bug h-14 min-w-[5rem] text-4xl">{reviewScoreText}</span>
                  <p className="m-0 -ml-2 flex flex-1 items-center bg-stage-deep pl-6 pr-4 font-display text-lg font-extrabold italic text-white">
                    Game&#39;s On Score
                  </p>
                </div>
                <div className="flex flex-col gap-5 p-4 md:p-6">
                  {contentReview.description ? (
                    <p className="m-0 hidden max-w-[72ch] text-[15px] leading-7 text-theme-text-secondary md:block">
                      {contentReview.description}
                    </p>
                  ) : null}
                  <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                    {reviewParts.map((part) => (
                      <div key={part.label} className="flex flex-col gap-2">
                        <div className="flex items-baseline justify-between gap-3">
                          <span className="text-[15px] font-medium text-theme-text">{part.label}</span>
                          <span className="font-display text-base font-semibold tabular-nums text-theme-text">
                            {part.value ?? "–"}
                          </span>
                        </div>
                        <div className="h-2 w-full bg-theme-surface">
                          <div
                            className="h-2 bg-signal"
                            style={{
                              width: Math.max(0, Math.min(10, Number(part.value) || 0)) * 10 + "%",
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="flex items-center gap-2 md:hidden">
                    <div className="relative h-6 w-6 shrink-0 overflow-hidden rounded-full">
                      <Image
                        src={contentReview.author[0].pictureProfile || DEFAULT_AVATAR}
                        fill
                        sizes="24px"
                        alt=""
                        className="object-cover"
                      />
                    </div>
                    <p className="m-0 text-sm font-medium text-theme-text">
                      By {contentReview.author[0].displayName}
                    </p>
                  </div>
                </div>
              </div>
              {/* The review itself */}
              <div className="min-w-0">
                {haveReview && props.reviewScore ? (
                  <Fragment>
                    <div className="group hidden h-full flex-col overflow-hidden rounded-[4px] bg-theme-card md:flex">
                      <a href={"/article/" + contentReview._id} className="relative block aspect-[16/9] w-full overflow-hidden bg-theme-surface">
                        <Image
                          src={reviewThumbnailSrc}
                          alt=""
                          className="object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]"
                          fill
                          sizes="(max-width: 1280px) 35vw, 420px"
                          unoptimized
                          onError={() => setReviewThumbnailError(true)}
                        />
                        <span className="tag-plate absolute left-0 top-0">รีวิว</span>
                      </a>
                      <div className="flex flex-1 flex-col justify-between gap-4 px-4 pb-4 pt-3">
                        <a href={"/article/" + contentReview._id}>
                          <p className="m-0 text-lg font-semibold leading-snug text-theme-text line-clamp-3 transition-colors group-hover:text-signal dark:group-hover:text-[#8DB4FF]">
                            {contentReview.title}
                          </p>
                        </a>
                        <div className="flex items-center gap-2">
                          <div className="relative h-6 w-6 shrink-0 overflow-hidden rounded-full">
                            <Image
                              src={contentReview.author[0].pictureProfile || DEFAULT_AVATAR}
                              fill
                              sizes="24px"
                              alt=""
                              className="object-cover"
                            />
                          </div>
                          <p className="m-0 text-sm font-medium text-theme-text">
                            By {contentReview.author[0].displayName}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="block md:hidden">
                      <PopularNewsCard
                        className=""
                        thumbnail={contentReview.thumbnail}
                        title={contentReview.title}
                        id={contentReview._id}
                        tag={contentReview.game}
                        textBlack={true}
                      />
                    </div>
                  </Fragment>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="container mx-auto xl:px-24 lg:px-12 md:px-8 px-4 w-full z-10 pt-6">
        <CommunityRating gameId={String(props.gameId)} />
      </div>
      {newData.length > 0 ? (
        <div className="container mx-auto xl:px-24 lg:px-12 flex flex-col gap-6 md:px-8 px-4 w-full z-10 pt-10">
          <div>
            {/* Header row: the game's name on a segment plate, the category
                tabs beside it, the sort control at the end */}
            <div className="flex flex-col gap-3 pb-6 md:flex-row md:items-center md:justify-between">
              <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2">
                <h2 className="seg-title max-w-full">{props.title}</h2>
                <div className="flex flex-wrap items-center gap-1" role="group" aria-label="Category">
                  {topicTabs
                    .filter((tab) => tab.show)
                    .map((tab) => (
                      <button
                        key={tab.key}
                        type="button"
                        onClick={() => selectTopic(tab.key)}
                        aria-pressed={topic === tab.key}
                        className={`tab-plate ${topic === tab.key ? "tab-plate-on" : ""}`}
                      >
                        {tab.label}
                      </button>
                    ))}
                </div>
              </div>
              <div className="flex justify-end">
                <Select
                  aria-label="Sort"
                  options={sortingOption}
                  onChange={(e: any) => setSorted(e.value)}
                  placeholder="Latest"
                  className="focus:border-none z-[40] text-sm"
                  styles={selectStyles}
                />
              </div>
            </div>
            <div className="w-full flex flex-col">
              <GameList category={topic} topicContents={topicContent} />
            </div>
            {totalContent > 0 ? (
              <nav aria-label="Pagination" className="flex justify-center md:mb-0 mb-10 mt-6">
                <ul className="m-0 inline-flex list-none flex-wrap items-center justify-center gap-1.5 p-0">
                  <li>
                    <button
                      type="button"
                      disabled={pages === 1}
                      onClick={() => setPages((prev) => prev - 1)}
                      className="flex h-9 w-9 items-center justify-center bg-theme-surface text-theme-text transition-colors duration-150 hover:text-signal disabled:cursor-not-allowed disabled:opacity-40 dark:hover:text-[#8DB4FF]"
                      aria-label="Previous page"
                    >
                      <FontAwesomeIcon icon={faAngleLeft}></FontAwesomeIcon>
                    </button>
                  </li>
                  {itemElements}
                  <li>
                    <button
                      type="button"
                      disabled={pages === calculatePagesCount(12, totalContent)}
                      onClick={() => setPages((prev) => prev + 1)}
                      className="flex h-9 w-9 items-center justify-center bg-theme-surface text-theme-text transition-colors duration-150 hover:text-signal disabled:cursor-not-allowed disabled:opacity-40 dark:hover:text-[#8DB4FF]"
                      aria-label="Next page"
                    >
                      <FontAwesomeIcon icon={faAngleRight}></FontAwesomeIcon>
                    </button>
                  </li>
                </ul>
              </nav>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="container mx-auto xl:px-24 lg:px-12 md:px-8 px-4 w-full z-10">
        <BannerRow
          subLocation="BOTTOM"
          mock="facebook"
          initialBannerAd={props.initialBottomAd as BannerAd | null | undefined}
          initialSquareAd={props.initialBottomSquareAd as BannerAd | null | undefined}
          className="my-6"
        />
      </div>
    </Fragment>
  );
};

export default GameComponent;
